import {useState} from 'react'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {StaticUnifiedDiffPreview} from '@github-ui/diff-lines/static-unified-diff-preview'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import type {StaticDiffLine} from '@github-ui/diff-lines/conversation-types'
import styles from './Tool.module.css'

const COLLAPSE_THRESHOLD = 20

interface DiffPreviewProps {
  diffLines: StaticDiffLine[]
  canCollapse: boolean
}

export function DiffPreview({diffLines, canCollapse}: DiffPreviewProps) {
  const [isExpanded, setIsExpanded] = useState(false)

  const shouldCollapse = canCollapse && diffLines.length > COLLAPSE_THRESHOLD
  const visibleLines = shouldCollapse && !isExpanded ? diffLines.slice(0, COLLAPSE_THRESHOLD) : diffLines

  return (
    <>
      <StaticUnifiedDiffPreview diffLines={visibleLines} tabSize={4} className={styles.diffPreview} />

      {shouldCollapse && (
        <button
          type="button"
          className={styles.diffPreviewFooter}
          onClick={() => setIsExpanded(!isExpanded)}
          aria-label={isExpanded ? 'Collapse diff content' : `Expand diff to show all ${diffLines.length} lines`}
          aria-expanded={isExpanded}
        >
          {isExpanded
            ? `Collapse ${diffLines.length - COLLAPSE_THRESHOLD} lines`
            : `Show all ${diffLines.length} lines`}
        </button>
      )}
    </>
  )
}
